import {
  MediaTypeChannel,
  MediaTypeChannelShort,
  MediaTypeVendor,
  MediaTypeVendorShort,
} from "models/bookingOrder"

const TUPLE_ID_SEPARATOR = "/"

function getVendorOptionValue(vt: MediaTypeVendor) {
  const mediaOwnerId = vt.mediaOwner.id
  const intermediaryId = vt.intermediary?.id
  const value = intermediaryId
    ? [mediaOwnerId, intermediaryId].join(TUPLE_ID_SEPARATOR)
    : mediaOwnerId

  return value
}

function getVendorOptionLabel(vt: MediaTypeVendor) {
  return `${vt.mediaOwner.name}${
    vt?.intermediary ? ` / ${vt.intermediary.name}` : ""
  }`
}

export function getVendorTupleOption(vt: MediaTypeVendor) {
  return { name: getVendorOptionLabel(vt), value: getVendorOptionValue(vt) }
}

export function normalizeVendor(stringId: string): MediaTypeVendorShort {
  const isTuple = stringId.indexOf(TUPLE_ID_SEPARATOR) > -1
  if (!isTuple) return { mediaOwnerId: stringId }

  const [mediaOwnerId, intermediaryId] = stringId.split(TUPLE_ID_SEPARATOR)
  return { mediaOwnerId, intermediaryId }
}

function getVPOptionValue(vt: MediaTypeChannel) {
  const mediaOwnerId = vt.mediaOwner.id
  const intermediaryId = vt.intermediary?.id
  const supplierProductId = vt.id
  const value = intermediaryId
    ? [mediaOwnerId, intermediaryId, supplierProductId].join(TUPLE_ID_SEPARATOR)
    : [mediaOwnerId, supplierProductId].join(TUPLE_ID_SEPARATOR)

  return value
}

function getVPOptionLabel(vt: MediaTypeChannel) {
  return `${vt.name} (${vt.mediaOwner.name}${
    vt?.intermediary ? `/ ${vt.intermediary.name}` : ""
  })`
}

export function getVendorProductTupleOption(vt: MediaTypeChannel) {
  return { name: getVPOptionLabel(vt), value: getVPOptionValue(vt) }
}

export function normalizeVendorProduct(
  stringId: string,
): MediaTypeChannelShort {
  const [mediaOwnerId, second, third] = stringId.split(TUPLE_ID_SEPARATOR)
  return {
    mediaOwnerId,
    intermediaryId: third && second,
    supplierProductId: third || second,
  }
}
